<template>
  <HorizontalDivider v-if="type === 'horizontal'"></HorizontalDivider>
  <VerticalDivider v-else></VerticalDivider>
</template>

<script>
import { default as HorizontalDivider } from './horizontal-divider';
import { default as VerticalDivider } from './vertical-divider';

export default {
  props: {
    type: {
      type: String,
      default: 'horizontal',
      required: false,
    }
  },
  components: { HorizontalDivider, VerticalDivider },
};
</script>
